// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const awsmobile = {
  'aws_project_region': 'us-east-1',
  'aws_cognito_identity_pool_id': 'us-east-1:ca2206d4-0f71-44ae-9639-fbc77ed89d2f',
  'aws_cognito_region': 'us-east-1',
  'aws_user_pools_id': 'us-east-1_YrDNHadxd',
  'aws_user_pools_web_client_id': '388t24e5qmgphlkvu279n9a6e6',
  'cookieStorage': {
    // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    'domain': process.env.AWS_COOKIE_LOCATION,
    // 'domain': 'http://localhost',
    // OPTIONAL - Cookie path
    'path': '/',
    // OPTIONAL - Cookie expiration in days
    'expires': 30,
    // OPTIONAL - Cookie secure flag
    'secure': false
  },
  'Storage': {
    'aws_cognito_identity_pool_id': 'us-east-1:ca2206d4-0f71-44ae-9639-fbc77ed89d2f'
  }
}

export default awsmobile



// WEBPACK FOOTER //
// ./src/aws-exports.js